import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle, Button, Box} from 'views/components';
import {Dropdown, DropdownMenuItem} from 'views/components';
import {Translate, translate} from 'views/module';

const ClientStatusEdit = (props) => {
  const [newStatus, setNewStatus] = React.useState('');

  const {
    clientData,
    clientBackend,
    isEditing,
    setIsEditing,
  } = props;

  const {status} = clientData;

  React.useEffect(() => {
    setNewStatus(status);
  }, [status]);

  const onSave = () => {
    clientBackend.detail.editStatus(newStatus, () => {
      setIsEditing(false);
    });
  };

  const onClose = () => {
    setIsEditing(false);
  };

  const allStatus = translate('client.Status');

  return (
    <Dialog onClose={onClose} open={isEditing}>
      <DialogTitle onClose={onClose}>
        <Translate expression='client.ClientDetail.ChangeStatusDialog.Title' />
      </DialogTitle>
      <DialogContent>
        <Box sx={{m: 1}}>
          <Dropdown
            value={newStatus}
            onChange={setNewStatus}
            label={translate('client.ClientDetail.ChangeStatusDialog.Status')}
          >
            {
              Object.entries(allStatus).map(([key, value]) => (
                <DropdownMenuItem key={key} value={key}>
                  {value.Title}
                </DropdownMenuItem>
              ))
            }
          </Dropdown>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Close' />
        </Button>
        <Button color="primary" onClick={onSave}>
          <Translate expression='generic.Save' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ClientStatusEdit.propTypes = {
  clientData: PropTypes.object.isRequired,
  clientBackend: PropTypes.object.isRequired,
  isEditing: PropTypes.bool.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(ClientStatusEdit);
